module.exports = __webpack_public_path__ + "b3dda7c321a5fc7fd95f028d96278af6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-4.png
// module id = 2707
// module chunks = 0